import { parseTemplate } from 'url-template';
import { Export } from '~/Api/User/ProductGroup/Export';
import ApiClient, { ApiClientErrorResponse } from '~/ApiClient';

import { ErrorResponse } from './ErrorResponse';

export interface Result {
	readonly export: Export;
}

export function createExportCNRefXls(client: ApiClient, userId: string, groupId: string): Promise<Result> {
	const url = parseTemplate('users/{userId}/product-groups/{groupId}/sk-max-price/export-cnref-xls');
	return client
		.fetch(url.expand({ userId, groupId }), { method: 'POST' })
		.then((response) => response.json())
		.catch((response) => ApiClientErrorResponse.wrapError(response, ErrorResponse));
}
